import { useState } from 'react';

import { accountsApi } from 'api/accountsApi';

import { useNextRouter } from 'hooks/UseNextRouter';
import { fireToast } from 'helpers/Toasts';

const useContactDealership = (args: { adId: number }) => {
  const { adId } = args;

  const { updateUrlByHref } = useNextRouter();

  const [isContactSellerModalOpen, setIsContactSellerModalOpen] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onWhatsAppButtonClick = async () => {
    setIsLoading(true);
    try {
      const {
        data: { url },
      } = await accountsApi.getWhatsAppLink(adId);
      updateUrlByHref(url);
    } catch (e) {
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
    setIsLoading(false);
  };

  const openContactSellerModal = () => setIsContactSellerModalOpen(true);

  const closeContactSellerModal = () => setIsContactSellerModalOpen(false);

  return {
    isContactSellerModalOpen,
    onWhatsAppButtonClick,
    isLoading,
    setIsLoading,
    openContactSellerModal,
    closeContactSellerModal,
  };
};

export { useContactDealership };
